
  import {defineComponent, inject, PropType} from "vue";
  import {t} from "@/mixin/mixins";
  import eventBus from "@/eventbus";
  import {MessageTypes} from "@/components/message-types";
  import CompanyLocationService, {CompanyLocationV2Dto} from "@/service/CompanyLocationService";
  import LocationUtils from "@/views/Inventories/InventoriesCompanyLocations/LocationUtils";

  export default defineComponent({
    name: "InventoriesCompanyLocationsListTile",
    props: {
      companyLocation: {
        type: Object as PropType<CompanyLocationV2Dto>,
        required: true,
        default: () => {}
      }
    },
    setup (props, context) {
      const openCompanyLocationDialog = (companyLocation: CompanyLocationV2Dto) => {
        context.emit("openCompanyLocationDialog", companyLocation);
      };

      let appRoot = inject("app-root");
      // @ts-ignore
      const confirmDialog = appRoot.confirmDialogComposition as InstanceType<typeof ConfirmDialogComposition>;
      const deleteCompanyLocation = (companyLocation: CompanyLocationV2Dto) => {
        const title = `${t("inventories.companyLocations.dialog.title.delete")}\n${companyLocation.name}`;
        const text = t("inventories.companyLocations.dialog.text.delete");
        confirmDialog.open(title, text)
          .then((confirmResult: boolean) => {
            if (confirmResult) {
              CompanyLocationService.deleteCompanyLocation(companyLocation.id)
                .then(() => {
                  eventBus.$emit(MessageTypes.COMPANY_LOCATION_DELETED, companyLocation.id);
                })
                .catch(() => {
                });
            }
          });
      };

      return {
        toAddressString: LocationUtils.toAddressString,
        openCompanyLocationDialog,
        deleteCompanyLocation
      };
    }
  });
